// extracted by mini-css-extract-plugin
export var divider = "_49-0";
export var dividerText = "_49-1";